import React, { createContext, useContext } from 'react';

interface ConfirmationModalContext {
    setErrorModal: (newModalContent: React.ReactElement | null, hwBackHandler?: () => void) => void;
    setProtectedContent: (
        protectedContent: unknown,
        successCallback: () => void,
        fromPlayer: boolean,
        closeCallback: ((isPinValid: boolean) => void) | undefined,
        forgotPinCallback: (() => void) | undefined,
        opaque: boolean
    ) => void;
    modalContent: React.ReactElement | null;
    setModalContent: (
        newModalContent: React.ReactElement | null,
        hwBackHandler?: () => void
    ) => void;
}

export const ConfirmationModalContext = createContext({} as ConfirmationModalContext);

// Functions are defined in AppModal

export const useConfirmationModal = () => useContext(ConfirmationModalContext);

// TODO: Fix in the future
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// eslint-disable-next-line react/display-name
export const withConfirmationModal = (Component) => (props) =>
    (
        <ConfirmationModalContext.Consumer>
            {({ setErrorModal, setProtectedContent, modalContent, setModalContent }) => (
                <Component
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...props}
                    setErrorModal={setErrorModal}
                    setProtectedContent={setProtectedContent}
                    modalContent={modalContent}
                    setModalContent={setModalContent}
                />
            )}
        </ConfirmationModalContext.Consumer>
    );
